var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollbar",staticClass:"home-page"},[_c('Widget',{attrs:{"no-show-complete":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }